const hu = {
  partners: {
    title: "A Mi",
    titleHighlight: "Partnereink",
    subtitle: "Vezető divatmárkák és kereskedők bíznak bennünk világszerte",
    trustedBy: "Akik Bíznak Bennünk"
  },
  navigation: {
    home: "Főoldal",
    download: "Letöltés",
    support: "Támogatás",
    privacy: "Adatvédelem",
    validate: "Érvényesítés",
    resetPassword: "Jelszó visszaállítása",
    scanYourStyle: "STÍLUS SZKENNELÉS",
    styleAnalysis: "STÍLUS ELEMZÉS",
    aiAdvice: "AI TANÁCSADÁS",
    downloadApp: "LETÖLTÉS",
    aboutOutfino: "AZ OUTFINÓRÓL",
    partners: "PARTNEREK",
    awards: "DÍJAK",
    news: "HÍREK",
    features: "FUNKCIÓK",
    aboutApp: "AZ ALKALMAZÁSRÓL"
  },
  hero: {
    title: "Mi írjuk a következő",
    titleHighlight: "streetwear",
    titleSuffix: "sztorit",
    subtitle: "Légy részese a történetünknek.",
    getStarted: "Kezdjük el",
    learnMore: "Tudjon meg többet",
    styleTips: [
      "Air Jordan 1 Retro High OG Chicago Lost And Found = instant G.O.A.T.",
      "Ehhez még egy Nike Tee, nagyot dobna a megjelenéseden 🔥",
      "Layerelj egy oversize inget a hoodie fölé – és kész a effortless drip."
    ],
    scrollDown: "Görgessen le",
    aboutButton: "Az Outfinóról"
  },
  features: {
    scan: {
      title: "🛍️ Dropok & ",
      titleHighlight: "Brandek",
      description: "Csapj le a legdurvább dropokra! Böngéssz a legnagyobb brandek limitált darabjai között, és vásárolj közvetlenül az appból. Fresh releaseek, exclusive itemek és instant cop – minden egy helyen, ami streetwearben számít."
    },
    analysis: {
      title: "👕 Outfit of the ",
      titleHighlight: "Day",
      description: "Készíts egy képet a szettedről, és versengj a 11 kategória bármelyikében – legyen az streetwear, vintage vagy minimal. Mérd össze a stílusodat másokkal, nézd meg barátaid összeállításait, fedezz fel új stílusokat és inspirálódj nap mint nap!",
      tags: {
        streetwear: "UTCAI DIVAT",
        casual: "HÉTKÖZNAPI", 
        urban: "VÁROSI",
        modern: "MODERN"
      }
    },
    ai: {
      title: "Ismerd meg az",
      titleHighlight: "AI modellünket",
      description: "Az alkalmazást saját AI modellünk hajtja, amely megtanulja a stílusodat. Minél többet használod, annál inkább hozzád igazodó javaslatokat és termékajánlásokat kapsz.",
      chatMessages: {
        casual: "Próbáljon egy kényelmes fehér pólót sötét farmerrel és friss tornacipővel. Rétegezzen egy könnyű bomberdzsekivel a tökéletes casual pénteki hangulatért.",
        streetwear: "Túlméretezett grafikus pulóver, cargo nadrág és masszív tornacipő. Adjon hozzá lánc kiegészítőket és crossbody táskát az utcai divat look teljessé tételéhez.",
        jacket: "Az Ön stílusa alapján vintage bőr bomberdzsekiket vagy minimalista farmer dzsekiket ajánlok. Mindkettő sokoldalú és időtálló."
      },
      suggestions: {
        title: "Kérdezzen rólam:",
        casualFriday: "Casual Péntek",
        streetwear: "Utcai Divat", 
        perfectJacket: "Tökéletes Dzseki"
      }
    }
  },
  support: {
    title: "SEGÍTSÉGRE VAN SZÜKSÉGE?",
    alternativeText: "Vagy küldjön e-mailt a",
    form: {
      name: "Név",
      email: "E-mail", 
      message: "Üzenet",
      send: "Küldés",
      errors: {
        missing: "Hiányzik valami!",
        invalidEmail: "Az e-mail cím nem érvényes!",
        failed: "Az üzenet küldése sikertelen."
      },
      success: "Az üzenet sikeresen elküldve!"
    }
  },
  awards: {
    title: "DÍJAINK",
    items: {
      topStartup: {
        title: "#17 az AI-ban",
        description: "A #17 helyen szerepelünk az F6S Top AI Companies listájában",
        year: "2025"
      },
      innovation: {
        title: "#1 a Divatban", 
        description: "A #1 helyen szerepelünk az F6S Top Fashion Companies listájában",
        year: "2025"
      },
      bestDesign: {
        title: "Legjobb App Dizájn",
        description: "Kiemelkedő felhasználói élmény és interfész tervezés", 
        year: "2025"
      }
    },
    viewOnF6S: "MEGTEKINTÉS F6S-EN"
  },
  newsletter: {
    title: "LEGFRISSEBB HÍREK",
    readMore: "Tovább olvasom",
    readLess: "Kevesebbet mutat",
    items: {
      aiUpdate: {
        title: "Nagy frissítés az AI Stílus Asszisztenshez",
        description: "AI-alapú stílus asszisztensünk most továbbfejlesztett személyre szabási algoritmusokkal rendelkezik, még pontosabb divat ajánlásokat nyújtva az Ön egyedi preferenciái, testalkata és életmódja alapján. A frissítés valós idejű trendelemzést és szezonális beállításokat tartalmaz.",
        date: "2024. dec. 15.",
        category: "Termékfrissítés"
      },
      partnership: {
        title: "Az Outfino Nagy Divatmárkákkal Társul",
        description: "Izgatottan jelentjük be stratégiai partnerségünket vezető divatkereskedőkkel, mint a Zara, H&M és Nordstrom. Ez az együttműködés exkluzív kedvezményeket, korai hozzáférést új kollekciókhoz és zökkenőmentes vásárlási integrációt hoz közvetlenül az Outfino alkalmazáson belül.",
        date: "2024. dec. 10.",
        category: "Partnerség"
      },
      appFeature: {
        title: "Új Virtuális Próbafülke Funkció",
        description: "Próbálja fel vásárlás előtt forradalmi AR-alapú virtuális próbafülkénkkel. Nézze meg, hogyan néznek ki a ruhák az Ön testalkatán, keverje és párosítsa a különböző darabokat, és mentse el kedvenc öltözékeit. Ez a funkció fejlett 3D modellezést használ a lehető legrealisztikusabb próba élményért.",
        date: "2024. dec. 5.",
        category: "Új Funkció"
      },
      fashionWeek: {
        title: "Outfino a 2025-ös Párizsi Divathéten",
        description: "Csatlakozzon hozzánk a Párizsi Divathéten, ahol bemutatjuk, hogyan alakítja át a technológia a személyes stílust. Találkozzon csapatunkkal, tapasztalja meg legújabb funkcióinkat élőben, és kapjon exkluzív betekintést vezető divattervezőktől a közelgő trendekről és a divat-technológia jövőjéről.",
        date: "2024. nov. 28.",
        category: "Esemény"
      }
    },
    subscribe: {
      title: "Maradjon naprakész",
      description: "Iratkozzon fel hírlevelünkre és ne maradjon le egyetlen frissítésről sem",
      emailPlaceholder: "Adja meg e-mail címét",
      button: "Feliratkozás"
    }
  },
  appDownload: {
    title: "Töltse le az Outfino Appot",
    description: "Kapjon személyre szabott stílus ajánlásokat útközben"
  },
  footer: {
    company: "Vállalat",
    usefulLinks: "Hasznos Linkek",
    documents: "Dokumentumok", 
    connect: "Kapcsolat",
    links: {
      scanFriends: "Szkenelje be barátait",
      actualStyle: "Az Ön valódi stílusa", 
      adviceFromAI: "Tanács az AI-tól",
      support: "Támogatás",
      gdpr: "GDPR",
      privacyPolicy: "Adatvédelmi irányelvek"
    },
    copyright: "Minden jog fenntartva."
  },
  download: {
    title: "Töltse le alkalmazásunkat",
    description: "Szerezze meg az alkalmazást eszközére",
    downloadNow: "Letöltés most",
    availableOn: "Elérhető"
  },
  privacy: {
    title: "Adatvédelmi irányelvek",
    lastUpdated: "Utoljára frissítve"
  },
  validation: {
    title: "Érvényesítés",
    validate: "Érvényesítés",
    enterCode: "Adja meg a kódot",
    submit: "Küldés"
  },
  resetPassword: {
    title: "Jelszó visszaállítása",
    email: "E-mail",
    newPassword: "Új jelszó",
    confirmPassword: "Jelszó megerősítése",
    resetButton: "Jelszó visszaállítása",
    backToLogin: "Vissza a bejelentkezéshez"
  },
  common: {
    loading: "Betöltés...",
    error: "Hiba",
    success: "Sikeres",
    cancel: "Mégse",
    save: "Mentés",
    close: "Bezárás",
    language: "Nyelv"
  }
};

export default hu;